<div class="stripe-card-container">
  <div class="input">
    <label class="required" i18n="@@payment_method.label.iban"> IBAN </label>
    <div
      id="stripe-iban-{{ uniqueInstanceId }}"
      class="form-control ng-dirty ng-touched"
      [ngStyle]="{ 'background-color': styles.inputFieldColor }"
      [class.ng-invalid]="stripeError$['iBan'] | async"
    >
    </div>
    <div class="error-container" *ngIf="stripeError$['iBan'] | async as error">
      {{ error }}
    </div>
  </div>
</div>

<orderform-cvc-dialog #cvcDialog></orderform-cvc-dialog>
